import React from "react";
import ReactDOM from "react-dom";
import "./Modal.css";
import ConfettiExplosion1 from "../Confetti/Confetti";
import badge from "../../assets/badge.png";

const BackDrop = (props) => {
  return <div className="backdrop" onClick={props.onConfirm}></div>;
};

const ModalOverlay = (props) => {
  return (
    <div className="modal">
      <header className="header">
        <h2>{props.title}</h2>
      </header>
      <div className="content">
        <p>{props.message}</p>
        <div>
          <img src={badge} className="badge-img" />
        </div>
      </div>
      <div className="image"></div>
      <footer className="actions">
        <button onClick={props.onConfirm} className="actions-btn">
          Ok, Thanks
        </button>
      </footer>
    </div>
  );
};

const Modal = (props) => {
  return (
    <div>
      {props.showConfetti &&
        ReactDOM.createPortal(
          <ConfettiExplosion1 />,
          document.getElementById("confetti-root")
        )}
      {ReactDOM.createPortal(
        <BackDrop onConfirm={props.onConfirm} />,
        document.getElementById("backdrop-root")
      )}
      {ReactDOM.createPortal(
        <ModalOverlay
          title={props.title}
          message={props.message}
          onConfirm={props.onConfirm}
        />,
        document.getElementById("overlay-root")
      )}
    </div>
  );
};

export default Modal;
